module.exports = __webpack_public_path__ + "media/Audio15_j.1cb4a917.wav";